"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
var useDebounce_1 = __importDefault(require("../../hooks/useDebounce"));
function InputSearch(_a) {
    var _b;
    var _c = _a.isPagination, isPagination = _c === void 0 ? false : _c, rest = __rest(_a, ["isPagination"]);
    var _d = (0, react_router_dom_1.useSearchParams)(), params = _d[0], setParams = _d[1];
    var _e = (0, react_1.useState)((_b = params.get('term')) !== null && _b !== void 0 ? _b : ''), term = _e[0], setTerm = _e[1];
    var filterDebounce = (0, useDebounce_1.default)(term, 500);
    (0, react_1.useEffect)(function () {
        if (filterDebounce) {
            params.set('term', filterDebounce);
            if (isPagination) {
                params.set('page', '1');
            }
            setParams(params);
        }
        else {
            params.delete('term');
            setParams(params);
        }
    }, [filterDebounce]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ sx: {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                border: '1px solid #CBCBCB',
                borderRadius: '4px',
                boxShadow: 'none',
            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { p: '8px', display: 'grid', placeItems: 'center' }, "aria-label": "search" }, { children: (0, jsx_runtime_1.jsx)(Search_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ id: "outlined-basic", placeholder: "Buscar", size: "small", color: "secondary", sx: {
                        '& .MuiInputBase-input, .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                            paddingLeft: 0,
                        },
                    }, focused: false, fullWidth: true, value: term, onChange: function (e) { return setTerm(e.target.value); }, inputMode: "search", type: "search" }, rest))] })) }));
}
exports.default = (0, react_1.memo)(InputSearch);
